var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","padding":"8px"}},[_c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.data,"scroll":{y:480},"pagination":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }